'use strict';

var bind = require('./util/bind');
var jsonp = require('./util/jsonp');
var tpl = require('./ucApiLogin/template.html');
var style = require('./ucApiLogin/template.css.string');
var loginUrl = "https://user.qunar.com/mobile/login.jsp";
var checkLoginUrl = "https://user.qunar.com/webApi/getLoginState.jsp?format=js";
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};
var isObject = function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
};
var noop = function noop() {};

module.exports = function (config) {
    var sdk = this,
        sniff = sdk.sniff,
        extend = sdk.util.extend,
        doc = document,
        loadUcAPI = location.protocol.toLowerCase().indexOf('file') === -1,
        loadedFlag = false,
        loadedCallbacks = [],
        _instance = null;

    if (loadUcAPI) {
        sdk.util.script(config.ucAPIScriptUrl, function () {
            loadedFlag = true;
            loadedCallbacks.forEach(function (callback) {
                return callback();
            });
        });
    }

    var ready = function ready(callback) {
        if (!loadUcAPI || loadedFlag) {
            callback();
        } else {
            loadedCallbacks.push(callback);
        }
    };

    var getEleByClass = function getEleByClass(name) {
        return doc.getElementsByClassName(name)[0];
    };

    var renderDefaultDialog = function renderDefaultDialog() {
        var target = doc.body;
        var element = doc.createElement('div');
        element.className = 'hysdk-ucapi-dialog';
        element.innerHTML = tpl;
        target.appendChild(element);

        var headElement = doc.getElementsByTagName('head')[0];
        var styleElement = doc.createElement('style');
        styleElement.innerHTML = style;
        headElement.appendChild(styleElement);
    };

    var onTouchMove = function onTouchMove(e) {
        e.preventDefault();
        e.stopPropagation();
    };

    var _checkLogin = function _checkLogin() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        jsonp(checkLoginUrl, {
            extend: extend,
            jsonp: 'callback',
            callback: 5000
        }, function (data, err) {
            if (isFunction(opts.success)) {
                opts.success(err ? {
                    ret: false
                } : {
                    ret: true,
                    login: data.ret && data.data && data.data.loginState === 2,
                    state: data.data && data.data.loginState || 0
                });
            }
        });
    };

    var createInstance = function createInstance(param) {
        var useDefault = true;
        if (param.useDefault === false) {
            useDefault = param.useDefault;
        }
        if (!getEleByClass('hysdk-ucapi-dialog') && useDefault) {
            renderDefaultDialog();
        }

        var instanceElement = extend({
            ucapiDialog: getEleByClass('hysdk-ucapi-dialog'),
            mobileInput: getEleByClass('hysdk-mobile'), //手机号输入框
            codeInput: getEleByClass('hysdk-code'), //动态码输入框
            codeBtn: getEleByClass('hysdk-code-btn'), //获取动态码按钮
            captchaArea: getEleByClass('hysdk-captcha-area'),
            captchaInput: getEleByClass('hysdk-captcha'), //验证码输入框
            captchaBtn: null, //刷新验证码
            errArea: getEleByClass('hysdk-err-area'), //错误提示信息
            loginBtn: getEleByClass('hysdk-login-btn'), //登录按钮
            cancelBtn: getEleByClass('hysdk-cancel-btn') //取消按钮
        }, param.instanceElement);

        var instanceConfig = extend({
            origin: param.origin || 'test',
            mobileInput: instanceElement.mobileInput,
            weixinAuth: true
        }, param.instanceConfig, {
            debug: config.debug
        });

        var ucapiDialogStyle = useDefault ? instanceElement.ucapiDialog.style : {};
        var captchaAreaStyle = useDefault ? instanceElement.captchaArea.style : {};
        var errAreaStyle = instanceElement && instanceElement.errArea && instanceElement.errArea.style;
        var errTip = function errTip(name) {
            config.debug && console.log('\u81EA\u5B9A\u4E49\u6A21\u677F\u767B\u5F55\u65F6' + name + '\u9ED8\u8BA4\u4E3A\u7A7A\u51FD\u6570');
        };
        var createImg = function createImg() {
            var img = new Image();
            img.className = 'hysdk-captcha-btn captcha-img';
            img.alt = '验证码';
            return img;
        };
        if (!instanceElement.captchaBtn && useDefault) {
            instanceElement.captchaBtn = createImg();
        }
        var instanceFunc = extend({
            readyFunc: noop,
            showDialog: function showDialog() {
                if (!useDefault) {
                    return;
                }
                if (sniff.ios) {
                    // 处理iOS下fixed定位的bug
                    ucapiDialogStyle.position = 'absolute';
                    ucapiDialogStyle.top = doc.body.scrollTop + 'px';
                    var dialogContent = getEleByClass('ucapi-content');
                    dialogContent.className += ' hack';
                    doc.body.addEventListener('touchmove', onTouchMove, false);
                }
                ucapiDialogStyle.display = 'block';
                errAreaStyle.display = 'none';
                instanceElement.mobileInput.value = '';
                instanceElement.codeInput.value = '';
                instanceElement.captchaInput.value = '';
            },
            hideDialog: function hideDialog() {
                if (!useDefault) {
                    return;
                }
                if (sniff.ios) {
                    // 处理iOS下fixed定位的bug
                    ucapiDialogStyle.position = 'fixed';
                    ucapiDialogStyle.top = 0;
                    var dialogContent = getEleByClass('ucapi-content');
                    dialogContent.className = dialogContent.className.replace(/\s*hack/g, '');
                    doc.body.removeEventListener('touchmove', onTouchMove);
                }
                ucapiDialogStyle.display = 'none';
            },
            getCodeSuccess: function getCodeSuccess() {
                if (!useDefault) {
                    errTip('getCodeSuccess');
                    return;
                }
                errAreaStyle.display = 'none';
                stopSendCode();
            },
            getCodeFail: function getCodeFail(err) {
                if (!useDefault) {
                    errTip('getCodeFail');
                    return;
                }
                instanceElement.errArea.innerHTML = '*' + err.errmsg;
                errAreaStyle.display = 'block';
            },
            loginSuccess: function loginSuccess() {
                if (!useDefault) {
                    errTip('loginSuccess');
                    return;
                }
                instanceFunc.hideDialog();
                errAreaStyle.display = 'none';
                if (isFunction(param.success)) {
                    param.success();
                }
            },
            loginFail: function loginFail(err) {
                if (!useDefault) {
                    errTip('loginFail');
                    return;
                }
                instanceElement.errArea.innerHTML = '*' + err.errmsg;
                errAreaStyle.display = 'block';
                if (isFunction(param.fail)) {
                    param.fail(err);
                }
            },
            changeCaptcha: function changeCaptcha() {
                if (!useDefault) {
                    errTip('changeCaptcha');
                    return;
                }
                getEleByClass('hysdk-captcha-btn').src = instance.getCaptchaUrl();
            },
            showCaptcha: function showCaptcha() {
                if (!useDefault) {
                    errTip('showCaptcha');
                    return;
                }
                var btn = getEleByClass('hysdk-captcha-btn');
                captchaAreaStyle.display = 'block';
                instanceElement.captchaInput.value = '';
                instanceElement.captchaBtn.src = instance.getCaptchaUrl();
                if (!btn) {
                    instanceElement.captchaArea.appendChild(instanceElement.captchaBtn);
                }
            },
            hideCaptcha: function hideCaptcha() {
                if (!useDefault) {
                    errTip('hideCaptcha');
                    return;
                }
                captchaAreaStyle.display = 'none';
                var btn = getEleByClass('hysdk-captcha-btn');
                if (btn) {
                    instanceElement.captchaArea.removeChild(btn);
                }
            }
        }, param.instanceFunc);

        var instance = ucAPI.quickLogin.create(instanceConfig);

        instance.instanceFunc = instanceFunc;

        var count = 60;
        var stopSendCode = function stopSendCode() {
            var btnStyle = instanceElement.codeBtn.style;
            if (count === 0) {
                instanceElement.codeBtn.removeAttribute('disabled');
                instanceElement.codeBtn.innerHTML = '获取动态码';
                btnStyle.color = '#19a9ba';
                count = 60;
                return;
            }
            instanceElement.codeBtn.setAttribute('disabled', 'disabled');
            instanceElement.codeBtn.innerHTML = count + '秒后获取';
            btnStyle.color = '#d7dce0';
            count--;
            setTimeout(function () {
                stopSendCode();
            }, 1000);
        };

        instanceElement.codeBtn.addEventListener('click', function () {
            instance.sendSMSCode({
                mobile: instanceElement.mobileInput.value,
                captcha: instanceElement.captchaInput.value,
                onsuccess: instanceFunc.getCodeSuccess,
                onfail: instanceFunc.getCodeFail
            });
        }, false);

        instanceElement.loginBtn.addEventListener('click', function () {
            instance.login({
                mobile: instanceElement.mobileInput.value,
                smscode: instanceElement.codeInput.value,
                captcha: instanceElement.captchaInput.value,
                onsuccess: instanceFunc.loginSuccess,
                onfail: instanceFunc.loginFail
            });
        }, false);

        if (instanceElement.captchaArea) {
            instanceElement.captchaArea.addEventListener('click', function (e) {
                var targetName = e.target.className;
                if (/hysdk-captcha-btn/.test(targetName)) {
                    instanceFunc.changeCaptcha();
                }
            }, false);
        } else if (instanceElement.captchaBtn && !useDefault) {
            instanceElement.captchaBtn.addEventListener('click', function (e) {
                instanceFunc.changeCaptcha();
            }, false);
        }

        if (instanceElement.cancelBtn) {
            instanceElement.cancelBtn.addEventListener('click', function () {
                instanceFunc.hideDialog();
            }, false);
        }

        instance.getCaptchaUrl();

        instance.on('ready', instanceFunc.readyFunc);

        instance.on('needShowCaptcha', instanceFunc.showCaptcha);
        instance.on('needHideCaptcha', instanceFunc.hideCaptcha);

        return instance;
    };

    var touchLogin = function touchLogin(data) {
        var url = '';
        if (isObject(data)) {
            Object.keys(data).forEach(function (key) {
                url += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
            });
        }
        location.href = isObject(data) ? loginUrl + '?' + url.replace(/&$/g, '') : loginUrl;
    };

    var loginHandle = function loginHandle() {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var useUcApi = param.useUcApi,
            useDefault = param.useDefault,
            data = param.data;

        if (useUcApi === false) {
            touchLogin(data);
            return;
        } else {
            ready(function () {
                if (!window.ucAPI) {
                    config.debug && console.log('缺少ucAPI脚本文件，检查是否正常引入该文件！');
                    touchLogin(data);
                } else {
                    var weixinAuth = param && param.instanceConfig ? param.instanceConfig !== false : true;
                    _instance = createInstance(param);
                    if (useDefault !== false) {
                        _instance.ready(function () {
                            var showLoginDialog = function showLoginDialog() {
                                var isShown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                                if (isShown) {
                                    if (isFunction(param.success)) {
                                        param.success();
                                    }
                                } else {
                                    if (!weixinAuth || !hysdk.sniff.browsers.wechat || location.href.indexOf('bindToken=') > -1) {
                                        _instance.instanceFunc.showDialog();
                                    }
                                }
                            };
                            // 修改 ucapi 的 isLogin 调用
                            if (isFunction(_instance.isLoginAsync)) {
                                _instance.isLoginAsync(function (res) {
                                    showLoginDialog(res);
                                });
                            } else {
                                _checkLogin({
                                    success: function success(data) {
                                        var _ref = data || {},
                                            login = _ref.login;

                                        showLoginDialog(login);
                                    }
                                });
                            }
                        });
                    }
                }
            });
        }
    };

    var apis = {
        /**
         * 唤起登录框或进行登录跳转<br />
         * 使用场景：登录
         * @method hysdk.login
         * @category Qunar
         * @example ./login.js[1-69]
         * @description
         *
         * **在携程客户端内使用携程用户登录**
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   √   |
         * | Hy Browser (qunar) | √    |
         * | Hy Browser (非qunar) | √    |
         * | touch   |   √  |
         * | wechat  |   √   |
         * | ctrip   |   √   |
         *
         * 微信客户端和浏览器环境登录支持两种登录方式：
         * + 1、 默认方式，跳转到 touch 端登录页面进行登录,在调用时，传入的参数，会直接拼接在路由上；
         * + 2、 通过配置 useUcApi 调用用户中心的登录组件<a href="http://wiki.corp.qunar.com/pages/viewpage.action?pageId=100510902" title="ucAPI说明文档" target="_blank">ucAPI</a>进行登录，hysdk默认提供一套模板（弹窗形式），同时支持调用方自定义模板和样式，在使用ucAPI组件登录时，仅支持qunar.com域，不支持如quhuhu.com qunar.it等域名。
         *
         * hy登录配置项说明：
         *
         * | 配置项 | 类型 | 描述 |
         * | :--: | :--: | :--: |
         * | shouldOpenLogin | Bool | 指示是否允许弹登录界面，不允许时未登录直接返回登录失败,true=允许, false=不允许 |
         * | extData | string | 传给 native 的数据，例如 origin(来源)，数据格式 source=aaa&&origin=bbb
         * | success | Function | 登录成功回调 |
         * | fail | Function | 登录失败回调 |
         * hy 环境调用时传入的任何参数都会传给 native
         *
         * 参考：<a href="http://wiki.corp.qunar.com/confluence/pages/viewpage.action?pageId=113380236" target="_blank">login.start 桥文档</a>
         *
         * ucAPI登录配置项说明：
         * <table style="text-align:center">
         *     <tr>
         *         <th colspan="2">配置项</th>
         *         <th>类型</th>
         *         <th>描述</th>
         *         <th>备注</th>
         *     </tr>
         *     <tr>
         *         <td colspan="2">useUcApi</td>
         *         <td>Bool</td>
         *         <td>是否使用ucAPI组件登录，默认true</td>
         *         <td>可选项</td>
         *     </tr>
         *     <tr>
         *         <td colspan="2">useDefault</td>
         *         <td>Bool</td>
         *         <td>是否使用hysdk默认模板，默认true</td>
         *         <td>可选项，当为false时，下列配置项必传</td>
         *     </tr>
         *     <tr>
         *         <td rowspan="6">instanceElement</td>
         *         <td>mobileInput</td>
         *         <td rowspan="6">Object（DOM节点对象）</td>
         *         <td>手机号输入框</td>
         *         <td rowspan="6">当useDefault为false时，必选配置</td>
         *     </tr>
         *     <tr>
         *         <td>codeInput</td>
         *         <td>动态码输入框</td>
         *     </tr>
         *     <tr>
         *         <td>codeBtn</td>
         *         <td>获取动态码按钮</td>
         *     </tr>
         *     <tr>
         *         <td>captchaInput</td>
         *         <td>验证码输入框</td>
         *     </tr>
         *     <tr>
         *         <td>captchaBtn</td>
         *         <td>刷新验证码</td>
         *     </tr>
         *     <tr>
         *         <td>loginBtn</td>
         *         <td>登录按钮</td>
         *     </tr>
         *     <tr>
         *         <td rowspan="6">instanceConfig</td>
         *         <td>origin</td>
         *         <td>String</td>
         *         <td>页面标识</td>
         *         <td>必选，页面标识，用于统计。格式：业务线-活动名称-日期，如：hotel-festival-20160415，注意：日期写死即可，不要使用new Date之类</td>
         *     </tr>
         *     <tr>
         *         <td>mobileInput</td>
         *         <td>Object</td>
         *         <td>手机号输入框</td>
         *         <td>必选，手机号对应的input元素如:doc.getElementById('mobile')</td>
         *     </tr>
         *     <tr>
         *         <td>syncLoginStatus</td>
         *         <td>Bool</td>
         *         <td>登录成功后是否同步登录态到大客户端，默认为true(仅在Hy下可用)</td>
         *         <td>可选</td>
         *     </tr>
         *     <tr>
         *         <td>weixinAuth</td>
         *         <td>Bool</td>
         *         <td>是否与微信绑定，默认为true</td>
         *         <td>可选</td>
         *     </tr>
         *     <tr>
         *         <td>greenShield</td>
         *         <td>Bool</td>
         *         <td>微信绑定是否展示绿盾授权中间页，默认true</td>
         *         <td>可选</td>
         *     </tr>
         *     <tr>
         *         <td>registerAuto</td>
         *         <td>Bool</td>
         *         <td>自动注册，默认为false</td>
         *         <td>可选</td>
         *     </tr>
         *     <tr>
         *         <td rowspan="8">instanceFunc</td>
         *         <td>readyFunc</td>
         *         <td rowspan="8">Function</td>
         *         <td>ucAPI组件ready时的回调</td>
         *         <td rowspan="8">可选配置，默认为空函数</td>
         *     </tr>
         *     <tr>
         *         <td>getCodeSuccess</td>
         *         <td>获取手机动态码成功回调</td>
         *     </tr>
         *     <tr>
         *         <td>getCodeFail</td>
         *         <td>获取手机动态码失败回调</td>
         *     </tr>
         *     <tr>
         *         <td>loginSuccess</td>
         *         <td>登录成功回调</td>
         *     </tr>
         *     <tr>
         *         <td>loginFail</td>
         *         <td>登录回调</td>
         *     </tr>
         *     <tr>
         *         <td>changeCaptcha</td>
         *         <td>刷新验证码图片</td>
         *     </tr>
         *     <tr>
         *         <td>showCaptcha</td>
         *         <td>显示验证码，当组件需要显示验证码时，内部调用该方法</td>
         *     </tr>
         *     <tr>
         *         <td>hideCaptcha</td>
         *         <td>隐藏验证码，当组件需要隐藏验证码时，内部调用该方法</td>
         *     </tr>
         *     <tr>
         *         <td style="text-align: left" colspan="5">注意：表格中提到的配置项必选，可选是针对在使用ucAPI登录的前提下。具体使用，可以参考<a href="http://ued.qunar.com/hy2/hysdk/demo/" title="ucAPI登录demo" target="_blank">demo</a>，调用 **hysdk.logout** 实现登出，**hysdk.getCaptchaUrl** 刷新验证码图片地址</td>
         *     </tr>
         * </table>
         * 参考：<a href="http://wiki.corp.qunar.com/confluence/pages/viewpage.action?pageId=109972607" target="_blank">ucapi 参数详细说明文档</a>
         *
         * touch 页登录配置说明：
         * <table style="text-align:center">
         *     <tr>
         *         <th colspan="2">配置项</th>
         *         <th>类型</th>
         *         <th>描述</th>
         *         <th>备注</th>
         *     </tr>
         *     <tr>
         *         <td rowspan="2">data</td>
         *         <td>ret</td>
         *         <td>String</td>
         *         <td>touch 页登录成功后返回的页面</td>
         *         <td>常用参数，直接拼接到 url 上</td>
         *     </tr>
         *     <tr>
         *         <td>origin</td>
         *         <td>String</td>
         *         <td>来源</td>
         *         <td>常用参数，直接拼接到 url 上</td>
         *     </tr>
         * </table>
         *  参考：<a href="http://wiki.corp.qunar.com/confluence/pages/viewpage.action?pageId=87337979" target="_blank">touch 登录页详细参数说明文档</a>
         *
         *  参考：<a href="http://wiki.corp.qunar.com/confluence/pages/viewpage.action?pageId=113382811" target="_blank">用户中心 beta 环境</a>
         */
        login: {
            hy: {
                key: 'login.start'
            },
            wechat: {
                handle: loginHandle
            },
            h5: {
                handle: loginHandle
            }
        },
        /**
         * 星图项目登录<br />
         * 使用场景：星图项目登录
         * @method hysdk.starLogin
         * @category Qunar
         * @example ./starLogin.js[1-18]
         * @description
         *
         *
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   √   |
         * | Hy Browser (qunar) | X    |
         * | Hy Browser (非qunar) | X    |
         * | touch   |   X  |
         * | wechat  |   X  |
         * | ctrip   |   X  |
         */
        starLogin: {
            hy: {
                key: 'star.login'
            }
        }
    };

    extend(sdk, {
        /**
         * 检测当前是否登录<br />
         * 使用场景：登录前检查
         * @method hysdk.checkLogin
         * @category Qunar
         * @example ./checkLogin.js
         * @description
         *
         * **在携程客户端内检查携程用户登录情况**
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   √   |
         * | Hy Browser (qunar) | √    |
         * | Hy Browser (非qunar) | √    |
         * | touch   |   √  |
         * | wechat  |   √   |
         * | ctrip   |   √   |
         *
         */
        checkLogin: _checkLogin,
        /**
         * 登出（在微信内会同时解绑微信关联）<br />
         * 使用场景：登出
         * @method hysdk.logout
         * @category Qunar
         * @example ./logout.js
         * @description
         *
         * **在携程客户端内使用携程用户登出**
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   √   |
         * | Hy Browser (qunar) | √    |
         * | Hy Browser (非qunar) | √    |
         * | touch   |   √  |
         * | wechat  |   √   |
         * | ctrip   |   √   |
         *
         */
        logout: function logout() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            ready(function () {
                if (window.ucAPI) {
                    if (!_instance) {
                        _instance = createInstance({});
                    }
                    _instance.logout(opts.success);
                } else {
                    if (isFunction(opts.fail)) {
                        opts.fail();
                    }
                }
            });
        },
        /**
         * 获取验证码（ucAPI验证码图片地址）<br />
         * 使用场景：刷新验证码图片
         * @method hysdk.getCaptchaUrl
         * @category Qunar
         * @example ./getCaptchaUrl.js
         * @description
         *
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   x   |
         * | Hy Browser (qunar) | X    |
         * | Hy Browser (非qunar) | X    |
         * | touch   |   √  |
         * | wechat  |   √   |
         * | ctrip   |   X   |
         *
         */
        getCaptchaUrl: function getCaptchaUrl() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (window.ucAPI) {
                if (!_instance) {
                    _instance = createInstance({});
                }
                var captchaUrl = _instance.getCaptchaUrl();
                if (captchaUrl && isFunction(opts.success)) {
                    opts.success(captchaUrl);
                }
                return captchaUrl;
            } else {
                if (isFunction(opts.fail)) {
                    opts.fail();
                }
            }
        },
        /**
         * 获取登录用户的信息<br />
         * 使用场景：获取用户信息
         * @method hysdk.getUserInfo
         * @category Qunar
         * @example ./getUserInfo.js
         * @description
         *
         * **在携程客户端内获取携程用户信息**
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   √   |
         * | Hy Browser (qunar) | √    |
         * | Hy Browser (非qunar) | √    |
         * | touch   |   √  |
         * | wechat  |   √   |
         * | ctrip   |   √   |
         *
         */
        getUserInfo: function getUserInfo() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            ready(function () {
                if (window.ucAPI) {
                    if (!_instance) {
                        _instance = createInstance({});
                    }
                    _instance.getUserInfo(opts.success);
                } else {
                    if (isFunction(opts.fail)) {
                        opts.fail();
                    }
                }
            });
        }
    });

    bind(sdk, apis, config);
};


//////////////////
// WEBPACK FOOTER
// ../plugins/qunar/loginSeries.js
// module id = 35
// module chunks = 1 3 4